import { render } from "./my-header.vue?vue&type=template&id=bddd0040&scoped=true"
import script from "./my-header.vue?vue&type=script&lang=js"
export * from "./my-header.vue?vue&type=script&lang=js"

import "./my-header.vue?vue&type=style&index=0&id=bddd0040&lang=css"
import "./my-header.vue?vue&type=style&index=1&id=bddd0040&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bddd0040"]])

export default __exports__